<template>
  <div class="dashboard-pages">
      <v-card class="pa-3">
          <v-layout row>
              <v-flex>
                  <dt-search-box
                      @typing="searchValue"
                      @reset-datatable="resetDataTable()"
                      @clear-search-field="search = null"
                      @reset-advanced-search="resetAdvancedSearch()"
                      advanced-search
                  >
                      <template v-slot:form="searchSlot">
                          <form @submit.prevent="searchSlot.search">
                              <v-layout row wrap>
                                  <v-flex xs2 pa-2>
                                      <v-autocomplete
                                          v-model="advancedSearch.select_date"
                                          :items="dateFilter"
                                          :label="`${$t('Select Date')}`"
                                          auto-select-first
                                          hide-details
                                          :error="errors.has('Select Date')"
                                          data-vv-name="Select Date"
                                          :menu-props="{ transition: 'slide-y-transition' }"
                                      />
                                  </v-flex>

                                  <v-flex xs2 pa-2 v-if="advancedSearch.select_date === 'DATE_PERIOD'">
                                      <v-menu v-model="startDateMenu" full-width max-width="290" :close-on-content-click="false">
                                          <v-text-field
                                              slot="activator"
                                              :value="advancedSearch.start_date"
                                              :label="$t('Start Date')"
                                              prepend-inner-icon="event"
                                              readonly
                                              hide-details
                                              data-vv-name="start_date"
                                              background-color="white"
                                              autocomplete="off"
                                              :error="errors.has('start_date')"
                                              v-validate="'date_format:yyyy-MM-dd'"
                                          />
                                          <v-date-picker @change="startDateMenu = false" v-model="advancedSearch.start_date" />
                                      </v-menu>
                                  </v-flex>

                                  <v-flex xs2 pa-2 v-if="advancedSearch.select_date === 'DATE_PERIOD'">
                                      <v-menu v-model="endDateMenu" full-width max-width="290" :close-on-content-click="false">
                                          <v-text-field
                                              slot="activator"
                                              :value="advancedSearch.end_date"
                                              :label="$t('End Date')"
                                              prepend-inner-icon="event"
                                              readonly
                                              hide-details
                                              data-vv-name="end_date"
                                              background-color="white"
                                              autocomplete="off"
                                              :error="errors.has('end_date')"
                                              v-validate="'date_format:yyyy-MM-dd'"
                                          />
                                          <v-date-picker @change="endDateMenu = false" v-model="advancedSearch.end_date" />
                                      </v-menu>
                                  </v-flex>

                                  <v-flex xs2 pa-2>
                                      <v-text-field
                                          v-model="advancedSearch.start_amount"
                                          :label="$t('Start Amount')"
                                          data-vv-name="start_amount"
                                          hide-details
                                          autocomplete="off"
                                          :error="errors.has('start_amount')"
                                          v-validate="'decimal:3|min_value:0'"
                                          data-vv-delay="1000"
                                      />
                                  </v-flex>

                                  <v-flex xs2 pa-2>
                                      <v-text-field
                                          v-model="advancedSearch.end_amount"
                                          :label="$t('End Amount')"
                                          data-vv-name="end_amount"
                                          hide-details
                                          autocomplete="off"
                                          :error="errors.has('end_amount')"
                                          v-validate="'decimal:3|min_value:0'"
                                          data-vv-delay="1000"
                                      />
                                  </v-flex>

                                  <v-flex xs2 pa-2>
                                      <v-autocomplete
                                          v-model="advancedSearch.product_type_id"
                                          :items="fullFixedAssetTypesList"
                                          :label="`${$t('Asset Type')}`"
                                          height="30px"
                                          auto-select-first
                                          hide-details
                                          data-vv-name="expense type"
                                          :menu-props="{ transition: 'slide-y-transition' }"
                                      />
                                  </v-flex>

                                  <v-flex xs2 pa-2>
                                      <v-autocomplete
                                          v-model="advancedSearch.vender_id_fk"
                                          :items="supplierList"
                                          :label="`${$t('Supplier')}`"
                                          height="30px"
                                          auto-select-first
                                          hide-details
                                          data-vv-name="Supplier"
                                          :menu-props="{ transition: 'slide-y-transition' }"
                                      />
                                  </v-flex>

                                  <v-layout justify-end align-center>
                                      <v-flex shrink>
                                          <v-btn flat class="grey--text" @click="searchSlot.reset">
                                              <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">clear</v-icon>
                                              {{ $t('datatable-reset') }}
                                          </v-btn>
                                          <v-btn type="submit" color="success">
                                              <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">filter_list</v-icon>
                                              {{ $t('Filter') }}
                                          </v-btn>
                                      </v-flex>
                                  </v-layout>

                                  <v-flex xs12 pb-2 pt-3><v-divider /></v-flex>
                              </v-layout>
                          </form>
                      </template>
                  </dt-search-box>
              </v-flex>
          </v-layout>
      </v-card>

    <v-card flat>
      <v-layout row>
        <v-layout row wrap justify-start align-end>
          <v-flex pa-2>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  style="margin:0 10px 0; height: 30px; width: 30px;"
                  :loading="loadThePrintBtn"
                  flat
                  fab
                  v-on="on"
                  color="primary"
                  @click="getNoPaginatedData('print')"
                >
                  <v-icon>print</v-icon>
                </v-btn>
              </template>
              <span>{{ $t(`Print Table`) }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  style="margin: 0; height: 30px; width: 30px"
                  fab
                  :loading="loadTheExportBtn"
                  flat
                  v-on="on"
                  color="primary"
                  @click="getNoPaginatedData('export')"
                >
                  <v-icon>fa-file-excel</v-icon>
                </v-btn>
              </template>
              <span>{{ $t(`Export Table`) }}</span>
            </v-tooltip>
          </v-flex>
        </v-layout>

        <v-layout row justify-end>
          <v-flex shrink pa-2>
            <v-btn
              dark
              color="primary"
              v-if="hasPermissions(['fixed_asset_purchases_store'])"
              @click="dialogs.addDialog = true"
            >
              <v-icon>add</v-icon>
              {{ $t('datatable-add-new') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-card>

    <v-card class="px-4 pb-4">
      <v-data-table
        v-show="isDatatable"
        :headers="headers"
        :items="resultData.data"
        :item-key="defaultSortBy"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="pagination.rowsPerPageItems"
        :total-items="resultData.total"
        :no-data-text="$t('No available data')"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <!--          <td>{{ props.item.purchase_id }}</td>-->
          <td>{{ props.item.bill_auto_number }}</td>
          <td>{{ props.item.asset_type_name }}</td>
          <td>{{ props.item.product_name }}</td>
          <td>{{ props.item.supplier_invoice_number }}</td>
          <td>{{ props.item.vender_name }}</td>
          <td>{{ props.item.purchase_quantity | currency }}</td>
          <td>{{ props.item.purchase_price | currency }}</td>
          <td>{{ props.item.grand_total_amount | currency }}</td>
          <td>{{ props.item.bill_date }}</td>
          <td v-if="hasActionsMenuPermissions()">
            <v-menu offset-y bottom :left="!$vuetify.rtl" :right="$vuetify.rtl" transition="slide-y-reverse-transition">
              <v-btn flat fab icon class="transparent py-2" slot="activator">
                <v-icon large class="grey--text actions-btn">more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-tooltip
                  v-if="hasPermissions(['fixed_asset_purchases_show'])"
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="viewRecord(props.item.purchase_id)">
                    <v-icon>chrome_reader_mode</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-view') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`View Purchase's information`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['fixed_asset_purchases_update']) &&
                      (props.item.bill_status === 'Open' || props.item.cash_or_opening_balance === 'Cash')
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="editRecord(props.item.purchase_id)">
                    <v-icon>edit</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-edit') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Edit Purchase's information`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['fixed_asset_purchases_close']) &&
                      props.item.bill_status === 'Open' &&
                      props.item.cash_or_opening_balance !== 'Cash'
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="closePurchaseRecord(props.item)">
                    <v-icon>fa-lock</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('close-purchase') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Close Purchase`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['fixed_asset_purchases_unclose']) &&
                      props.item.cash_or_opening_balance !== 'Cash' &&
                      props.item.bill_status === 'Close' &&
                      (props.item.payment_status === 'Not Paid' || props.item.payment_status === null)
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="openPurchaseRecord(props.item.purchase_id)">
                    <v-icon>fa-lock-open</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('open-purchase') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Open Purchase`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['single_statement_payment_store']) &&
                      props.item.bill_status === 'Close' &&
                      props.item.payment_status !== 'Paid' &&
                      props.item.cash_or_opening_balance !== 'Cash' &&
                      props.item.cash_or_opening_balance !== 'Opening Balance'
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="singlePayment(props.item)">
                    <v-icon>payment</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('Payment') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Add Payment For This Statement`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['fixed_asset_purchase_return_store']) &&
                      (props.item.bill_status === 'Close' || props.item.cash_or_opening_balance === 'Cash')
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="returnPurchaseRecord(props.item.purchase_id)">
                    <v-icon>fa-undo</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('return-purchase') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Return Purchase`) }}</span>
                </v-tooltip>

                <v-divider
                  v-if="
                    hasPermissions(['fixed_asset_purchases_destroy']) &&
                      (props.item.bill_status === 'Open' || props.item.cash_or_opening_balance === 'Cash')
                  "
                />

                <v-tooltip
                  v-if="
                    hasPermissions(['fixed_asset_purchases_destroy']) &&
                      (props.item.bill_status === 'Open' || props.item.cash_or_opening_balance === 'Cash')
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="showConfirmDeletion(props.item.purchase_id)">
                    <v-icon class="red--text">delete</v-icon>
                    <v-list-tile-content class="red--text px-3">{{ $t('datatable-delete') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t('Delete Purchase Record') }}</span>
                </v-tooltip>
              </v-list>
            </v-menu>
          </td>
        </template>

        <template v-slot:footer v-if="resultData.footer">
            <td :colspan="headers.length - 5">
              <strong>Total</strong>
            </td>
            <td colspan="1">
              <strong>{{ resultData.footer.purchase_quantity | currency }}</strong>
            </td>
            <td colspan="1">
              <strong>{{ resultData.footer.purchase_price | currency }}</strong>
            </td>
            <td colspan="3">
              <strong>{{ resultData.footer.grand_total_amount | currency }}</strong>
            </td>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">{{
          $t('Sorry, No results found for your search criteria')
        }}</v-alert>
      </v-data-table>

      <dt-pagination
        :resultData="resultData"
        :pagination="pagination"
        :perPageNumber="perPageNumber"
        @page-changed="pageChanged"
        @per-page-changed="resultsPerPageChanged"
      />
    </v-card>

    <add-fixed-purchase
      :addDialog="dialogs.addDialog"
      @reset-datatable="resetDataTable(), resetAllErrors(true)"
      @hidemodal="resetAllErrors(true), (dialogs.addDialog = false)"
      @add-supplier="dialogs.addSupplier = true"
      @add-fixed-asset="dialogs.addFixedAsset = true"
    />

    <edit-fixed-purchase
      :editDialog="dialogs.editDialog"
      @updated="updateDatatableResult(), (dialogs.editDialog = false), (allowGettingData = false)"
      @hidemodal="resetAllErrors(true), (dialogs.editDialog = false)"
      @add-supplier="dialogs.addSupplier = true"
      @add-fixed-asset="dialogs.addFixedAsset = true"
    />

    <confirm-deletion
      :deleteDialog="dialogs.deleteDialog"
      :btnDeleteLoading="btnDeleteLoading"
      @hidemodal="dialogs.deleteDialog = false"
      @confirm="deleteAction()"
    />

    <view-fixed-purchase :viewDialog="dialogs.viewDialog" @hidemodal="dialogs.viewDialog = false" />

    <return-fixed-purchase
      :returnDialog="dialogs.returnDialog"
      @hidemodal="dialogs.returnDialog = false"
      @returned="updateDatatableResult(), (dialogs.returnDialog = false), (allowGettingData = false), goToReturn()"
    />

    <add-single-payment
      :paymentDialog="dialogs.paymentDialog"
      :statement="statement"
      :account="accountPayableInfo"
      @reset-datatable="resetDataTable(), showPayments()"
      @hidemodal="resetAllErrors(true), (dialogs.paymentDialog = false)"
    />

    <print-export-component
      :printExportDialog="dialogs.printExportDialog"
      :tableHeader="tableHeader"
      :tableBody="tableBody"
      :clickedButton="clickedButton"
      @hidemodal="dialogs.printExportDialog = false"
    />

    <add-supplier
      :addDialog="dialogs.addSupplier"
      @reset-datatable="setVendersList()"
      @hidemodal="resetAllErrors(true), (dialogs.addSupplier = false)"
    />

    <add-fixed-asset
      :addDialog="dialogs.addFixedAsset"
      @reset-datatable="updateFullFixedAssetsList()"
      @hidemodal="dialogs.addFixedAsset = false"
      @add-fixed-asset-type="dialogs.addFixedAssetType = true"
    />

    <add-fixed-asset-type
      :addDialog="dialogs.addFixedAssetType"
      @reset-datatable="updateFullFixedAssetTypesList()"
      @hidemodal="dialogs.addFixedAssetType = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import Axios from 'axios'

export default {
  components: {
    dtSearchBox: () => import('@/views/_partials/AppSearchBox.vue'),
    dtPagination: () => import('@/views/_partials/AppDatatablePagination.vue'),
    addFixedPurchase: () => import('./addFixedPurchase.vue'),
    editFixedPurchase: () => import('./editFixedPurchase.vue'),
    viewFixedPurchase: () => import('./viewFixedPurchase.vue'),
    returnFixedPurchase: () => import('./returnFixedPurchase.vue'),
    addSinglePayment: () => import('@/views/accounting/accountPayable/statements/addSinglePayment.vue'),
    printExportComponent: () => import('@/views/_partials/printExportComponent.vue'),
    addSupplier: () => import('@/views/suppliers/addSupplier.vue'),
    addFixedAsset: () => import('@/views/inventory/fixedAssets/addFixedAsset.vue'),
    addFixedAssetType: () => import('@/views/inventory/fixedAssetTypes/addFixedAssetType.vue')
  },

  data() {
    return {
      dialogs: {
        viewDialog: false,
        addDialog: false,
        editDialog: false,
        deleteDialog: false,
        returnDialog: false,
        paymentDialog: false,
        printExportDialog: false,
        addSupplier: false,
        addFixedAsset: false,
        addFixedAssetType: false
      },
      advancedSearch: {},
      startDateMenu: false,
      endDateMenu: false,
      tableBody: [],
      tableHeader: [],
      loadThePrintBtn: false,
      loadTheExportBtn: false,
      clickedButton: '',
      deleteId: 0,
      btnDeleteLoading: false,
      isDatatable: true,
      search: null,
      oldSearch: null,
      loading: false,
      defaultSortBy: 'purchase_id',
      perPageNumber: 10,
      pagination: {
        sortBy: this.defaultSortBy,
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 1
      },
      oldPagination: {},
      headers: [
        // {
        //   text: this.$t('ID'),
        //   value: 'purchase_id',
        //   align: 'left',
        //   sortable: true
        // },
        { text: this.$t('Bill Number'), value: 'bill_auto_number' },
        { text: this.$t('Type'), value: 'asset_type_name' },
        { text: this.$t('Product'), value: 'product_name' },
        {
          text: this.$t('Supplier Invoice Number'),
          value: 'supplier_invoice_number'
        },
        { text: this.$t('Supplier'), value: 'vender_name' },

        {
          text: `${this.$t('Quantity')}`, value: 'purchase_quantity' },
        {
          text: `${this.$t('Price')} (${localStorage.systemCurrency})`,
          value: 'purchase_price'
        },
        {
          text: `${this.$t('Grand Total')} (${localStorage.systemCurrency})`,
          value: 'grand_total_amount'
        },

        { text: this.$t('Bill Date'), value: 'bill_date' }
        // { text: this.$t('Payment Type'), value: 'cash_or_opening_balance' },
        // { text: this.$t('Bill Status'), value: 'bill_status' },
        // { text: this.$t('Payment Status'), value: 'payment_status' }
      ],
      allowGettingData: true,
      accountPayableInfo: {},
      statement: {}
    }
  },

  mounted() {
    this.setAppBarTitle({
      title: this.$t('Fixed Asset Purchases'),
      icon: 'attach_money'
    })

    this.setVendersList()
    this.updateFullFixedAssetsList()
    this.updateFullFixedAssetTypesList()

    if (this.hasActionsMenuPermissions()) {
      this.headers.push({
        text: this.$t('datatable-actions'),
        value: '',
        sortable: false,
        class: 'myClass'
      })
    }
  },

  computed: {
    ...mapGetters({
      resultData: 'purchasesFixedAssets/getPurchaseList',
      fullFixedAssetTypesList: 'fixedAssetTypes/getFullFixedAssetTypesList',
      supplierList: 'suppliers/getFullVendersList',
      dateFilter: 'expenses/getDateFilter'
    })
  },

  watch: {
    pagination: {
      immediate: false,
      deep: false,
      handler() {
        let p = this.pagination
        let op = this.oldPagination
        if (p.sortBy !== op.sortBy || p.descending !== op.descending) {
          op.sortBy = p.sortBy
          op.descending = p.descending
          p.page = 1
          this.updateDatatableResult()
          this.allowGettingData = !this.allowGettingData
        } else if (this.allowGettingData || this.search !== this.oldSearch) {
          this.oldSearch = this.search
          this.updateDatatableResult()
          this.allowGettingData = !this.allowGettingData
        }
      }
    }
  },

  methods: {
    ...mapActions({
      resetAllErrors: 'errors/resetAllErrors',
      setErrorsList: 'errors/setErrorsList',
      updateResult: 'purchasesFixedAssets/updatePurchaseList',
      deleteRecord: 'purchasesFixedAssets/deletePurchase',
      fetchPurchaseInfo: 'purchasesFixedAssets/fetchPurchaseInfo',
      fetchStatementInfo: 'accountStatements/fetchStatementInfo',
      closePurchase: 'purchasesFixedAssets/closePurchase',
      openPurchase: 'purchasesFixedAssets/openPurchase',
      setVendersList: 'suppliers/setFullVendersList',
      updateFullFixedAssetsList: 'fixedAssets/updateFullFixedAssetsList',
      updateFullFixedAssetTypesList: 'fixedAssetTypes/updateFullFixedAssetTypesList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    getNoPaginatedData(clickedButton) {
      this.clickedButton = clickedButton
      if (clickedButton === 'print') {
        this.loadThePrintBtn = true
      } else if (clickedButton === 'export') {
        this.loadTheExportBtn = true
      }
      this.tableBody = []
      this.tableHeader = []
      this.tableHeader = this.headers
      this.tableHeader = this.tableHeader.filter(f => f.text !== 'Actions' && f.text !== 'الاجراءات')

      Axios.get('fixed_asset_purchases_index', {
        params: {
          is_paginated: 0,
          search: this.search,
          ...this.advancedSearch,
          isFiltered: this.isFiltered
        }
      })
        .then(response => {
          this.tableBody = response.data.data
          this.loadThePrintBtn = false
          this.loadTheExportBtn = false
          this.dialogs.printExportDialog = true
        })
        .catch(() => {
          this.loadThePrintBtn = false
          this.loadTheExportBtn = false
          this.dialogs.printExportDialog = false
        })
    },

    hasActionsMenuPermissions() {
      return helpers.userHasPermissions([
        'fixed_asset_purchases_show',
        'fixed_asset_purchases_update',
        'fixed_asset_purchases_destroy',
        'fixed_asset_purchases_unclose',
        'fixed_asset_purchases_close',
        'single_statement_payment_store'
      ])
    },

    updateDatatableResult() {
      this.loading = true
      let payload = {
        ...this.pagination,
        search: this.search,
        advancedSearch: this.advancedSearch

      }
      this.updateResult(payload)
        .then(() => {
          this.pagination.page = this.resultData.current_page
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    resetDataTable() {
      this.allowGettingData = true

      this.pagination = {
        sortBy: null,
        descending: true,
        page: 1,
        rowsPerPage: this.perPageNumber,
        totalItems: 1
      }
      this.search = this.oldSearch = null
      this.advancedSearch = {}
    },

    resultsPerPageChanged(val) {
      this.perPageNumber = val
      this.pagination.rowsPerPage = val
      this.pagination.page = 1
      this.updateDatatableResult()
    },

    resetAdvancedSearch() {
      this.advancedSearch = {}
    },

    pageChanged(val) {
      this.pagination.page = val
      this.updateDatatableResult()
    },

    searchValue(val) {
      this.isFiltered = 1
      this.search = val

      if (this.oldSearch === this.search) {
        this.updateDatatableResult()
      }
    },

    viewRecord(id) {
      this.fetchPurchaseInfo(id).then(() => {
        this.dialogs.viewDialog = true
      })
    },

    editRecord(id) {
      this.fetchPurchaseInfo(id).then(() => {
        this.dialogs.editDialog = true
      })
    },

    showConfirmDeletion(id) {
      this.deleteId = id
      this.dialogs.deleteDialog = true
    },

    deleteAction() {
      this.btnDeleteLoading = true
      this.deleteRecord(this.deleteId)
        .then(() => {
          this.deleteId = 0
          this.btnDeleteLoading = false
          this.dialogs.deleteDialog = false
          let payload = {
            ...this.pagination,
            search: this.search
          }
          this.updateResult(payload)
        })
        .catch(() => {
          this.deleteId = 0
          this.btnDeleteLoading = false
          this.dialogs.deleteDialog = false
        })
    },

    closePurchaseRecord(item) {
      const payload = {
        id: item.purchase_id,
        cash_or_opening_balance: item.cash_or_opening_balance
      }
      this.closePurchase(payload).then(() => {
        let payload = {
          ...this.pagination,
          search: this.search
        }
        this.updateResult(payload)
      })
    },

    openPurchaseRecord(id) {
      this.openPurchase(id).then(() => {
        let payload = {
          ...this.pagination,
          search: this.search
        }
        this.updateResult(payload)
      })
    },

    returnPurchaseRecord(id) {
      this.fetchPurchaseInfo(id).then(() => {
        this.dialogs.returnDialog = true
      })
    },

    singlePayment(item) {
      this.fetchStatementInfo(item.payable_statement_id).then(() => {
        this.statement = {
          payable_statement_id: item.payable_statement_id,
          amount: item.total_amount
        }
        this.accountPayableInfo = {
          account_payable_id: item.account_payable_id,
          total_debit: item.total_debit,
          total_balance: item.total_balance,
          total_credit: item.total_credit,
          vender_name: item.vender_name
        }

        this.dialogs.paymentDialog = true
      })
    },

    goToReturn() {
      this.$router.push({ name: 'accounting-purchases-return-fixed-asset' })
    },

    showPayments() {
      this.$router.push({
        name: 'accounting-account-payable-payments',
        query: {
          account_payable_id: this.accountPayableInfo.account_payable_id,
          name: this.accountPayableInfo.vender_name,
          commission: false
        }
      })
    }
  }
}
</script>

<style scoped />
